/* lua.js generated code 0.3.0 */

require("clover/data/UserManager")
var Event = require("cocos/framework/components/event")
UserCash = xClass("UserCash", Event)
UserCashEvent = table(
    [1, "Increase", "USERCASHEVENT.INCREASE"],
    [1, "Decrease", "USERCASHEVENT.DECREASE"],
    [1, "Update", "USERCASHEVENT.UPDATE"]
)
var instance = null
UserCash.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserCash.new()
    }
    return instance
}
UserCash.prototype.ctor = function () {
    var self = this
    self.bind(self)
    self.lockedCash = 0
}
UserCash.prototype.addCash = function (num) {
    var self = this
    var user = UserManager.getInstance().getUserRef()
    user.setCash(user.getCash() + num)
    self.dispatchEvent(table([1, "name", UserCashEvent.Increase], [1, "num", num]))
    self.dispatchEvent(table([1, "name", UserCashEvent.Update]))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserCash.prototype.consumeCash = function (num) {
    var self = this
    var user = UserManager.getInstance().getUserRef()
    user.setCash(Math.max(user.getCash() - num, 0))
    self.dispatchEvent(table([1, "name", UserCashEvent.Decrease], [1, "num", num]))
    self.dispatchEvent(table([1, "name", UserCashEvent.Update]))
    if (NetworkConfig.writeLocalDataStorage) {
        Localhost.getInstance().flushCurrentUserData()
    } else {
        cc.log("Did not write user data to the device.")
    }
}
UserCash.prototype.lockCash = function (num) {
    var self = this
    self.lockedCash = self.lockedCash + num
}
UserCash.prototype.unlockCash = function (num) {
    var self = this
    self.lockedCash = Math.max(self.lockedCash - num, 0)
}
UserCash.prototype.getCash = function () {
    var self = this
    // WARN: maybe multi result
    return UserManager.getInstance().getUserRef().getCash()
}
UserCash.prototype.checkCash = function (num) {
    var self = this
    return self.getAvaliableCash() >= num
}
UserCash.prototype.getAvaliableCash = function () {
    var self = this
    // WARN: maybe multi result
    return Math.max(self.getCash() - self.lockedCash, 0)
}
function convert(num) {
    num = tonumber(num) || 0
    if (num >= 100000) {
        return Math.floor(num / 10000) + "万"
    }
    return num
}
//显示用
UserCash.prototype.getAvaliableCashString = function () {
    var self = this
    // WARN: maybe multi result
    return convert(self.getAvaliableCash())
}
